<app-modal
  [showHeader]="false"
  [saveButtonName]="'Wiki'"
  (save)="onWikiClick()"
  [cancelButtonName]="'BUTTON.CLOSE'"
  [saveButtonExists]="showWikiButton()"
>
  <ng-container body>
    <div class="guide-container">
      @if (data() && data().items?.length > 0) {
        <app-guide-image-view [items]="data().items"></app-guide-image-view>
      } @else if (!loading()) {
        <div class="image">
          <img
            src="../../../../assets-common/default/logo_error_icon.svg"
            alt=""
            draggable="false"
            />

        </div>
        <p class="no-data">{{ 'ERROR.NO_HELP_IMAGES' | translate }}</p>
<!--        <p class="no-data">{{ 'ERROR.NO_RECORDS' | translate }}</p>-->
      } @else {
        <app-skeleton></app-skeleton>
      }
    </div>
  </ng-container>
</app-modal>
